import defaultsDeep from "lodash/defaultsDeep"

const DEF_OPTS = {
    "tree": {},
    "active_path": "",
    "mode": "esito",
    "label_open": "",
    "label_close": "",
};

const OPTS = defaultsDeep({}, window.TREENAV_OPTIONS, DEF_OPTS);

export default OPTS;